const hexColorPattern = /^#[0-9a-fA-F]{3,8}$/;
const rgbColorPattern = /^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/;

export function isValidColor(color: string): boolean {
  return hexColorPattern.test(color) || rgbColorPattern.test(color);
}

export function getColorName(color: string): string {
  // Convert rgb(35, 31, 32) to 231f20 format
  const rgbMatch = color.match(rgbColorPattern);
  if (rgbMatch) {
    const [, r, g, b] = rgbMatch;
    return `${parseInt(r!, 10).toString(16).padStart(2, '0')}${parseInt(g!, 10)
      .toString(16)
      .padStart(2, '0')}${parseInt(b!, 10).toString(16).padStart(2, '0')}`;
  }
  return color.startsWith('#') ? color.slice(1) : color;
}
